import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";

import { faFile } from "@fortawesome/pro-regular-svg-icons";

import SharePointImage from "../../../../../../assets/icons/icon-sharepoint.png";
import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { Icon } from "../../../../../components/Shared/Icon/Icon";
import { translationKeys } from "../../../../../models/app-translation-keys";

import "./KnowledgeBaseTypeIcon.scss";

interface IKnowledgeBaseTypeIconProps {
  isSpoKnowledgebase: boolean;
  compact?: boolean;
  setIsTooltipVisible?: (visible: boolean) => void;
  isActive: boolean;
}

export const KnowledgeBaseTypeIcon: FunctionComponent<IKnowledgeBaseTypeIconProps> = (
  props: IKnowledgeBaseTypeIconProps,
) => {
  const { t } = useTranslation();
  const typeIconRef = useRef<HTMLDivElement>(null);

  const cmsTranslationKeys = translationKeys.adminArea.cms;

  return (
    <div className="knowledge-base-icon" ref={typeIconRef}>
      <TooltipWrapper
        targetRef={typeIconRef}
        content={
          props.isSpoKnowledgebase
            ? t(cmsTranslationKeys.spoKnowledgeBase.title)
            : t(cmsTranslationKeys.knowledgeBase.title)
        }
        position="right"
        onShow={() => props.setIsTooltipVisible?.(true)}
        onHide={() => props.setIsTooltipVisible?.(false)}
      />
      {props.isSpoKnowledgebase ? (
        <img
          src={SharePointImage}
          className={
            props.compact
              ? "knowledge-base-type-icon-image knowledge-base-type-icon-image--compact"
              : "knowledge-base-type-icon-image"
          }
          alt={t(cmsTranslationKeys.spoKnowledgeBase.title)}
        />
      ) : (
        <Icon icon={faFile} iconSize={props.compact ? "xs" : "sm"} color={props.isActive ? "inverse" : "muted"} />
      )}
    </div>
  );
};
